// Historial de pedidos -- requiere cuenta (JWT), no existe para
// invitados. Mismo patrón que direcciones.js/auth.js: el JWT viaja como
// `?token=...`. GET /pedidos ya trae los items anidados por pedido, así
// que no hace falta un fetch por pedido para ver el detalle.
import { request } from './ecommerceClient';
import { getStoredAuth } from './auth';

const authParams = () => {
  const { token } = getStoredAuth();
  return token ? { token } : {};
};

export const getPedidos = () => request('/pedidos', { params: authParams() });
